import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Header from './components/Header';
import UploadMasterPage from './components/UploadMaster';
import InspectionForm from './pages/Inspection';
import UserCreation from './pages/UserCreation';
import PaymentForm from './pages/PaymentForm';
import './utils/sessionHandler'; // Import the session handler
import MastersManagement from './pages/Masters';
import InspectionList from './pages/InspectionList';
import SameStageReport from './pages/Reports';
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  
  if (!token || !user) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

function App() {
  const handleLogout = () => {
    // Clear localStorage
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    // Redirect to login
    window.location.href = '/';
  };

  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/" element={<Login />} />
        
        {/* Protected Routes */}
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Header onLogout={handleLogout} />
              <Dashboard />
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/upload" 
          element={
            <ProtectedRoute>
              <Header onLogout={handleLogout} />
              <UploadMasterPage />
            </ProtectedRoute>
          } 
        />
             <Route 
          path="/reports" 
          element={
            <ProtectedRoute>
              <Header onLogout={handleLogout} />
              <SameStageReport/>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/upload" 
          element={
            <ProtectedRoute>
              <Header onLogout={handleLogout} />
              <UploadMasterPage />
            </ProtectedRoute>
          } 
        />

            <Route 
          path="/list" 
          element={
            <ProtectedRoute>
              <Header onLogout={handleLogout} />
              <InspectionList />
            </ProtectedRoute>
          } 
        />
           <Route 
          path="/master" 
          element={
            <ProtectedRoute>
              <Header onLogout={handleLogout} />
              <MastersManagement />
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/inspect" 
          element={
            <ProtectedRoute>
              <Header onLogout={handleLogout} />
              <InspectionForm />
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/user-creation" 
          element={
            <ProtectedRoute>
              <Header onLogout={handleLogout} />
              <UserCreation />
            </ProtectedRoute>
          } 
        />
                <Route 
          path="/payment" 
          element={
            <ProtectedRoute>
              <Header onLogout={handleLogout} />
              <PaymentForm />
            </ProtectedRoute>
          } 
        />
        
        {/* Catch all route - redirect to dashboard if logged in, login if not */}
        <Route 
          path="*" 
          element={
            localStorage.getItem('token') ? 
            <Navigate to="/dashboard" replace /> : 
            <Navigate to="/" replace />
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;